import { render, staticRenderFns } from "./QuizProgressCard.vue?vue&type=template&id=c95ddf22&scoped=true"
import script from "./QuizProgressCard.vue?vue&type=script&lang=js"
export * from "./QuizProgressCard.vue?vue&type=script&lang=js"
import style0 from "./QuizProgressCard.vue?vue&type=style&index=0&id=c95ddf22&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95ddf22",
  null
  
)

export default component.exports